import { BriefcaseBusiness, Eye, Footprints, Home, Store, Trees } from 'lucide-react';
import type { ReactNode } from 'react';
import type { ToolMode } from '../types/core';
import { useGameStore } from '../simulation/store';
import { costForZone } from '../simulation/systems/zoning';
import { IconButton } from './IconButton';

interface ToolConfig {
  readonly mode: ToolMode;
  readonly label: string;
  readonly icon: ReactNode;
}

const tools: readonly ToolConfig[] = [
  { mode: 'residential', label: `Residential ${costForZone('residential')}`, icon: <Home size={19} /> },
  { mode: 'commercial', label: `Commercial ${costForZone('commercial')}`, icon: <Store size={19} /> },
  { mode: 'workspace', label: `Workspace ${costForZone('workspace')}`, icon: <BriefcaseBusiness size={19} /> },
  { mode: 'park', label: `Parks ${costForZone('park')}`, icon: <Trees size={19} /> },
  { mode: 'explore', label: 'Explore', icon: <Eye size={19} /> },
  { mode: 'walk', label: 'Walk My Town', icon: <Footprints size={19} /> }
];

export function Toolbar() {
  const selectedTool = useGameStore((state) => state.selectedTool);
  const setTool = useGameStore((state) => state.setTool);
  const progression = useGameStore((state) => state.progression);

  return (
    <aside className="pointer-events-none absolute bottom-4 left-1/2 z-30 w-[calc(100%-1.5rem)] max-w-3xl -translate-x-1/2 md:bottom-5">
      <div className="glass-panel pointer-events-auto flex flex-wrap items-center justify-center gap-2 rounded-lg p-2">
        {tools.map((tool) => (
          <IconButton
            key={tool.mode}
            label={tool.label}
            active={selectedTool === tool.mode}
            onClick={() => setTool(tool.mode)}
          >
            {tool.icon}
          </IconButton>
        ))}
        <div className="ml-0 flex max-w-full flex-wrap items-center gap-1 border-t border-hive-ink/10 pt-2 text-xs font-semibold text-hive-ink/70 md:ml-2 md:border-l md:border-t-0 md:pl-2 md:pt-0">
          {progression.unlockedServices.length === 0 ? (
            <span className="rounded bg-white/50 px-2 py-1">Hamlet</span>
          ) : (
            progression.unlockedServices.slice(0, 5).map((service) => (
              <span key={service} className="rounded bg-white/50 px-2 py-1 capitalize">
                {service}
              </span>
            ))
          )}
        </div>
      </div>
    </aside>
  );
}
